export const FETCH_ORGANIZATIONS_DATA = "user_profile/fetch_organizations_data"
export const FETCH_ORGANIZATIONS_DATA_SUCCESS =
    "user_profile/fetch_organizations_data_success"
export const FETCH_ORGANIZATIONS_DATA_FAILURE =
    "user_profile/fetch_organizations_data_failure"

export const FETCH_ACCESS_RIGHTS = "user_profile/fetch-access-rights"
export const FETCH_ACCESS_RIGHTS_SUCCESS =
    "user_profile/fetch-access-rights-success"
export const FETCH_ACCESS_RIGHTS_FAILURE =
    "user_profile/fetch-access-rights-failure"

export const SELECT_SHIPPER = "user_profile/select_shipper"
export const CHECK_EBOL_WO_ACCESS = "user_profile/check_ebol_wo_access"
export const CHECK_EBOL_WO_ACCESS_SUCCESS =
    "user_profile/check_ebol_wo_access_success"
export const CHECK_EBOL_WO_ACCESS_FAILURE =
    "user_profile/check_ebol_wo_access_failure"
export const SET_ENHANCED_VISIBILITY_REDIRECT =
    "user_profile/set_enhanced_visibility_redirect"
export const SHOW_ENHANCED_VISIBILITY_MENU =
    "user_profile/show_enhanced_visibility_menu"

export const HIDE_ENHANCED_VISIBILITY_MENU =
    "user_profile/hide_enhanced_visibility_menu"
